import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: string;
  title: string;
  cover: string;
  duration: string;
  category: string;
  views: number;
  date: string;
}

export default function VideoCard({ id, title, cover, duration, category, views, date }: VideoCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return (v / 10000).toFixed(1) + '万';
    return v.toString();
  };

  return (
    <Link
      to={`/article/${id}`}
      className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
    >
      <div className="relative aspect-video overflow-hidden">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
        <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md bg-black/60 text-white text-xs font-medium">
          {duration}
        </span>
        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 rounded-full bg-primary-500 text-white text-xs font-medium">
            {category}
          </span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
          {title}
        </h3>
        <div className="flex items-center gap-3 mt-2 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {formatViews(views)}
          </span>
          <span>{date}</span>
        </div>
      </div>
    </Link>
  );
}